import { Button, Dropdown, Input, Radio, Select } from "antd";
import { useState } from "react";
import { BiFilterAlt, BiSortAlt2 } from "react-icons/bi";
import { IoIosArrowDown } from "react-icons/io";

import search from "../../assets/images/searchIcon.png";
import excel from "../../assets/svg/excel.svg";

const { Option } = Select;
const SortOptions = ({
  sortName,
  sortIcon,
  handleSortClick,
  isMed = false,
}) => {
  const [selectedSort, setSelectedSort] = useState("newest");
  const [open, setOpen] = useState(false);

  const baseSortOptions = [
    { label: "Newest First", value: "newest" },
    { label: "Oldest First", value: "oldest" },
    { label: "Alphabetic A-Z", value: "ascending" },
    { label: "Alphabetic Z-A", value: "descending" },
  ];

  const medSortOptions = [
    { label: "MRP: Low to High", value: "small" },
    { label: "MRP: High to Low", value: "high" },
  ];

  const sortOptions = isMed
    ? [...baseSortOptions, ...medSortOptions]
    : baseSortOptions;

  const handleApply = () => {
    handleSortClick(selectedSort);
    setOpen(false);
  };

  const menuItems = sortOptions.map((option) => ({
    key: option.value,
    label: (
      <div
        className="d-flex align-items-center gap-2 px-3 py-2"
        onClick={(e) => {
          e.stopPropagation();
          setSelectedSort(option.value);
        }}
      >
        <Radio checked={selectedSort === option.value} />
        <span>{option.label}</span>
      </div>
    ),
  }));

  return (
    <Dropdown
      arrow={true}
      menu={{
        items: [
          ...menuItems,
          {
            type: "divider",
          },
          {
            key: "apply",
            label: (
              <div className="py-2" onClick={handleApply}>
                {/* <hr style={{ border: "1px solid #7d7d7d" }} /> */}
                <span className="w-100 text-primarycolor fs16fw600 d-flex justify-content-center">
                  Apply
                </span>
              </div>
            ),
          },
        ],
      }}
      trigger={["click"]}
      open={open}
      onOpenChange={setOpen}
      className="sortByContent"
    >
      <Button className="d-flex align-items-center gap-2">
        {sortName} <BiSortAlt2 size={18} />
      </Button>
    </Dropdown>
  );
};

const FilterOptions = ({
  setLimit = () => {},
  onChangeSearch = () => {},
  handleSortClick = () => {},
  setFilterShow = () => {},
  limit,
  sortName = "Sort by",
  // search,
  filterBy = true,
  showOption = false,
  downloadExcel = false,
  onClickDownload = () => {},
  isMed = false,
  title = "",
}) => {
  const filterSortBtns = () => {
    return (
      <div className="rightContent">
        {filterBy ? (
          <Button
            className="filterByBtn me-2"
            onClick={() => setFilterShow(true)}
          >
            <span>Filter By</span>
            <BiFilterAlt size={20} />
          </Button>
        ) : (
          <></>
        )}
        <SortOptions
          sortName={sortName}
          handleSortClick={handleSortClick}
          isMed={isMed}
        />
      </div>
    );
  };

  return (
    <div
      className={`filterSortOptions my-3 ${
        downloadExcel ? "" : "justify-content-between"
      }`}
    >
      <div className="leftContent">
        <div>Show</div>
        <div>
          <Select
            suffixIcon={<IoIosArrowDown size={18} />}
            showSearch
            value={limit}
            onChange={(value) => setLimit(value)}
            className="me-2 w-100"
          >
            <Option value="10">10</Option>
            <Option value="25">25</Option>
            <Option value="50">50</Option>
            <Option value="100">100</Option>
          </Select>
        </div>
        <div>Entries</div>
        <Input
          type="text"
          placeholder="Search"
          // allowClear
          className="antdSearchInput"
          prefix={<img src={search} alt="Search Icon" />}
          onInput={(e) => {
            if (title === "Pincode") {
              e.target.value = e.target.value
                .replace(/[^0-9]/g, "")
                .slice(0, 6);
            }
          }}
          onChange={(e) => onChangeSearch(e.target.value)}
          style={{ width: 200 }}
        />
      </div>
      {downloadExcel ? (
        <div
          className={`d-flex ${
            downloadExcel ? "w-100 justify-content-between" : ""
          }`}
        >
          {filterSortBtns()}
          <Button onClick={onClickDownload} className="downloadExcel">
            Download
            <img src={excel} alt="" />
          </Button>
        </div>
      ) : (
        title !== "Pincode" && title !== "viewMed" && filterSortBtns()
      )}
    </div>
  );
};

export default FilterOptions;
